/**
 * @Author : ShaJiaJing
 * @Date : 2019/6/18
 * @Version : 1.0
 * @Content : 机器人/设计器 购买、续费接口
 */
import fetch from '@/utils/fetch2'
const payUrl = process.env.VUE_APP_REPORTURL
const options = { isForm: true }
/**
 * 获取机器人、设计器列表
 * @param agentIds  查询机器人id
 * @param filterIds  过滤机器人id
 * @param studioId  设计器id
 * @param filterStudioId  过滤设计器id
 * 多个id用逗号分割
 * @returns {*}
 */
export function getProductList (params) {
  return fetch.get('/agents/renewallist', params)
}

/**
 * 获取机器人、设计器购买时长
 * @returns {*}
 */
export function getPriceList () {
  return fetch.get('/sertime')
}

/**
 * 支付订单-支付宝
 * type: 0 - 支付宝, 1 - 微信, 2 - PayPal, 3 - 兑换卡
 * @returns {*}
 */
export function payOrder (type, data) {
  const options = { isForm: true }
  let url = payUrl
  // const options = { isForm: true, baseURL: '/pay' }
  // let url = ''
  if (type === 0) {
    // 未支付/待支付 + no
    // 新支付
    url += '/ali/web/pay'
  } else if (type === 1) {
    url += '/wx/get/image'
  } else if (type === 2) {
    url += '/paypal/topay'
    // url = 'http://192.168.0.186/paypal/topay'
    // return fetch.post(url, data)
  } else if (type === 3) {
    url += '/ecard/pay'
  }
  return fetch.post(url, data, options)
}

/**
 * 获取订单详情（微信）
 */
export function getOrderDetail (outTradeNo) {
  return fetch.get(payUrl + '/console/v1/pay/order', { outTradeNo })
}

/**
 * 获取支付状态（微信）
 */
export function getOrderStatus (outTradeNo) {
  const options = { isForm: true }
  return fetch.post(payUrl + '/wx/get/search', { outTradeNo }, options)
}

/**
 * 获取支付状态（paypal）
 */
export function getPOrderStatus (params) {
  return fetch.get(payUrl + '/paypal/execute', params)
}

/**
 * 取消订单
 * @param outTradeNo
 * @returns {*}
 */
export function cancelOrder (outTradeNo) {
  const options = { isForm: true }
  return fetch.post(payUrl + '/ali/closed', { outTradeNo }, options)
}

/**
 * 删除订单
 * @param outTradeNo
 * @returns {*}
 */
export function deleteOrder (outTradeNo) {
  return fetch.post(payUrl + '/console/v1/pay/order/delete', { outTradeNo }, options)
}

/**
 * 根据兑换码获取代理商信息
 * @param {String} promotionCode 合作码
 */
export function getProCodeDisc (promotionCode) {
  return fetch.get(`${payUrl}admin/v1/seller/detail`, { promotionCode })
}
